import { createListenerMiddleware, UnknownAction } from '@reduxjs/toolkit'
import { transformRTKQueryFnActionType } from '@/src/store/listeners'
import { isEqual } from 'lodash'
import { sentryCaptureException } from '@/src/common/hooks/useLogError'
import { z } from 'zod/v4'

export const isErrorsAbortedDueToFalseCondition = (error: unknown) =>
  isEqual(error, {
    name: 'ConditionError',
    message: 'Aborted due to condition callback returning false.',
  })

export const isRTKQueryAction = (action: UnknownAction): boolean =>
  // @ts-expect-error King: Lazy
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  action.meta?.arg?.endpointName && action.meta.requestId

export const captureQueryFnErrors = createListenerMiddleware()

export const ErrorLike = z.union([
  z.instanceof(Error),
  z.object({
    name: z.string(),
    message: z.string(),
  }),
])

captureQueryFnErrors.startListening({
  predicate: (action) => isRTKQueryAction(action) && action.type.endsWith('/rejected'),
  effect: (action) => {
    const { error, type, meta } = action

    // Skip reporting errors that are aborted due to RTK Query condition returning false
    if (isErrorsAbortedDueToFalseCondition(error)) {
      return
    }

    const baseQueryMeta =
      typeof meta === 'object' && meta && 'baseQueryMeta' in meta ? meta.baseQueryMeta : undefined

    sentryCaptureException(ErrorLike.safeParse(baseQueryMeta).success ? baseQueryMeta : error, {
      title: `RTKQ Error: ${transformRTKQueryFnActionType(action)}`,
      type,
      meta,
      error,
    })
  },
})
